import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const NotificationMenuContainer = styled.div`
  padding: 23px 0 0 0;
  background-color: ${Variables.colors.complementary};
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 16px 16px;
    .sort-box {
      width: 130px;
      height: 30px;
      font-size: 13px;
    }
    h1 {
      margin: 0;
      font-size: ${Variables.font_sizes.x2_large};
      color: ${Variables.colors.complementary_900};
      font-weight: ${Variables.font_weight.regular};
    }
  }
`;
export const NotificationListContainer = styled.div`
  overflow-y: auto;
  height: auto;
  max-height: 75vh;
  overflow-x: hidden;
  left: 0;
  width: 100%;
`;

export const FeedbackModalContainer = styled.div`
  .modal-title-icon {
    &:before {
      font-size: ${Variables.font_sizes.x2_medium} !important;
    }
  }
  .response-modal-body-container {
    overflow-y: auto;
    white-space: pre-wrap;
    max-height: 70vh;
    .response-modal-date {
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x2_large};
      line-height: 1.55;
    }
    .response-modal-subject {
      color: ${Variables.colors.primary_vivid};
      font-size: ${Variables.font_sizes.x_medium};
      font-weight: ${Variables.font_weight.medium};
      line-height: 1.57;
      margin-top: 8px;
    }
    .response-modal-title {
      max-width: 500px;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x2_large};
      line-height: 1.55;
      margin-top: 24px;
    }
    .images {
      display: flex;
      margin-top: 16px;
      align-items: center;
      .file {
        width: 32px;
        height: 32px;
      }
    }
    .response-modal-description {
      max-width: 400px;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x_medium};
      line-height: 1.57;
      text-align: justify;
      margin-top: 14px;
    }
    .response-modal-rate-section {
      margin-top: 24px;
      display: flex;
      .rating {
        display: flex;
        width: fit-content;
        .unrated-stars {
          display: flex;
          flex-direction: row-reverse;
        }
      }
      .selected {
        color: ${Variables.colors.yellow};
        &:hover {
          color: ${Variables.colors.yellow};
          & ~ .selected {
            color: ${Variables.colors.complementary_500};
          }
        }
      }
      .unselected {
        color: ${Variables.colors.complementary_500};

        &:hover {
          color: ${Variables.colors.yellow};
          &::before {
            content: "\\ea5a";
          }
          & ~ .unselected {
            color: ${Variables.colors.yellow};
            &::before {
              content: "\\ea5a";
            }
          }
        }
      }
      i {
        &:before {
          margin-left: 8px;
        }
      }
    }
    .response-modal-answer-info {
      font-size: ${Variables.font_sizes.x_medium};
      font-weight: ${Variables.font_weight.medium};
      line-height: 1.57;
      margin-top: 12px;
      .ans-date {
        color: ${Variables.colors.complementary_800};
      }
      .ans-name {
        color: ${Variables.colors.complementary_700};
      }
    }
  }
`;
